import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 32,
  height: 20,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
      backgroundColor: "#4663ff",
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 4,
    "&.Mui-checked": {
      transform: "translateX(12px)",
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 12,
    backgroundColor: "#3c3c40",
    border: "2px solid #fff",
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 20,
    opacity: 1,
    backgroundColor: "white",
    boxSizing: "border-box",
    border: "2px solid #3c3c40 !important",
    padding: "5px",
  },
  "& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
    backgroundColor: "#4663ff", // Color de la perilla cuando está marcado },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    borderRadius: 20,
    opacity: 1,
    backgroundColor: "white",
    boxSizing: "border-box",
    border: "2px solid #3c3c40 !important",
    padding: "5px",
  },
}));

export default CustomSwitch;
